import { useState, useEffect } from "react"
import { createPortal } from "react-dom"
import { setCookie } from "../../utils/cookies"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog.tsx"
import { Button } from "../ui/button.tsx"
import { Input } from "../ui/input.tsx"
import { Label } from "../ui/label.tsx"

 
export function LoginModal({ isOpen, onClose, onLoginSuccess }) {
  const [step, setStep] = useState("phone")
  const [mode, setMode] = useState("login") // "login" or "signup"
  const [phone, setPhone] = useState("")
  const [phoneError, setPhoneError] = useState("")
  const [otp, setOtp] = useState("")
  const [loading, setLoading] = useState(false)
  const [showNotFoundPopup, setShowNotFoundPopup] = useState(false)
  const [otpError, setOtpError] = useState("")
  const [registrationData, setRegistrationData] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    gender: "",
    email: "",
    address: "",
    city: "",
    stateId: ""
  })
  const [states, setStates] = useState([])

  useEffect(() => {
    fetch("/apis/web/states")
      .then(r => r.json())
      .then(data => {
        if (data?.success && Array.isArray(data.data)) {
          setStates(data.data.map(s => ({ id: s.state_id, name: s.state_name?.trim() })))
        }
      })
      .catch(() => {})
  }, [])
 
const handleSendOTP = async (e) => {
  e.preventDefault();
 
  if (!phone || phone.length !== 10 || !/^[6-9]\d{9}$/.test(phone)) {
    setPhoneError("Please enter a valid 10-digit mobile number")
    return;
  }
  setPhoneError("")
 
  if (mode === "signup") {
    setStep("otp");
    setTimer(30);
    return;
  }

  setLoading(true);
 
  try {
    const response = await fetch("/apis/web/checkPatientAndSendOTP", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({ mobileNo: `91${phone}` }),
    });
 
    const data = await response.json();
 
    if (data.status === 0) {
      setStep("otp");
    } else if (data.status === 2) {
      setShowNotFoundPopup(true);
    } else {
      alert(data.message || "Failed to send OTP");
    }
  } catch (error) {
    console.error(error);
    alert("API Error");
  }
 
  setLoading(false);
};
 
  const handleVerifyOTP = async (e) => {
  e.preventDefault();
  setOtpError("");

  if (mode === "signup") {
    setLoading(true);
    try {
      const response = await fetch("/apis/web/verifysignupOTP", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobileNo: phone, otp }),
      });
      const data = await response.json();
      if (data.status === 0) {
        setStep("registration");
      } else {
        setOtpError(data.message || "Invalid OTP");
      }
    } catch (error) {
      console.error(error);
      setOtpError("Something went wrong");
    }
    setLoading(false);
    return;
  }

  setLoading(true);
 
  try {
    const response = await fetch("/apis/web/verifyOTP", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({ mobileNo: `91${phone}`, otp })
    });
 
    const data = await response.json();
 
    if (data.status === 0) {
      if (data.isNewPatient) {
        setStep("registration");
      } else {
        const userData = data.user;
        setCookie("accessToken", data.accessToken, 1);
        setCookie("refreshToken", data.refreshToken, 7);
        setCookie("user", JSON.stringify(userData), 7);
        window.dispatchEvent(new CustomEvent("user-updated", { detail: userData }));
        onLoginSuccess(userData);
        onClose();
        resetForm();
      }
    } else {
      alert(data.message || "Invalid OTP");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");
  }
 
  setLoading(false);
};
 
  const handleRegistration = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const genderMap = { male: "M", female: "F", other: "O" }
      const response = await fetch("/apis/web/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          FirstName: registrationData.firstName,
          LastName: registrationData.lastName,
          Gender: genderMap[registrationData.gender] || registrationData.gender,
          Dob: registrationData.dob,
          Email: registrationData.email,
          Mobile: phone,
          city: registrationData.city,
          Address: registrationData.address,
          stateId: registrationData.stateId,
          CountryMobileCode: "+91",
          country: "India",
          Relation: "000",
        }),
      })
      const data = await response.json()
      if (data.status === 0) {
        const userData = data.user || {
          name: `${registrationData.firstName} ${registrationData.lastName}`,
          mobile: phone,
        }
        if (data.accessToken) setCookie("accessToken", data.accessToken, 1)
        if (data.refreshToken) setCookie("refreshToken", data.refreshToken, 7)
        setCookie("user", JSON.stringify(userData), 7)
        window.dispatchEvent(new CustomEvent("user-updated", { detail: userData }))
        onLoginSuccess(userData)
        onClose()
        resetForm()
      } else {
        alert(data.message || "Registration failed")
      }
    } catch (error) {
      console.error(error)
      alert("Registration failed")
    }
    setLoading(false)
  }
 
  const handleRegisterYes = async () => {
    setLoading(true)
    try {
      const response = await fetch("/apis/web/sendotp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobileNo: phone }),
      })
      const data = await response.json()
      if (data.status === 0) {
        setShowNotFoundPopup(false)
        setMode("signup")
        setStep("otp")
        setTimer(30)
      } else {
        alert(data.message || "Failed to send OTP")
      }
    } catch (error) {
      console.error(error)
      alert("Failed to send OTP")
    }
    setLoading(false)
  }

  const resetForm = () => {
    setStep("phone")
    setMode("login")
    setPhone("")
    setOtp("")
    setShowNotFoundPopup(false)
    setRegistrationData({
      firstName: "",
      lastName: "",
      dob: "",
      gender: "",
      email: "",
      address: "",
      city: "",
      stateId: ""
    })
  }

  const [timer, setTimer] = useState(30)
  useEffect(() => {
  if (timer <= 0) return

  const interval = setInterval(() => {
    setTimer((prev) => prev - 1)
  }, 1000)

  return () => clearInterval(interval)
}, [timer])

const handleResendOTP = async () => {
  if (mode === "signup") {
    try {
      await fetch("/apis/web/sendotp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobileNo: phone }),
      })
      setTimer(30)
    } catch (error) {
      alert("Failed to resend OTP")
    }
    return;
  }

  try {
    await fetch("/apis/web/checkPatientAndSendOTP", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({ mobileNo: `91${phone}` }),
    })

    setTimer(30)
  } catch (error) {
    alert("Failed to resend OTP")
  }
}

  const notFoundPopup = showNotFoundPopup
    ? createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center" style={{ pointerEvents: "auto" }}>
          <div className="fixed inset-0 bg-black/80" onClick={() => setShowNotFoundPopup(false)} />
          <div className="relative bg-white rounded-lg w-[90vw] max-w-[350px] p-6" style={{ zIndex: 10000, pointerEvents: "auto" }}>
            <div className="text-center space-y-4">
              <p className="text-sm font-medium text-gray-800">Mobile number not found! Do you want to register?</p>
              <div className="flex justify-center gap-3">
                <button
                  type="button"
                  className="px-6 py-2 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50"
                  onClick={() => setShowNotFoundPopup(false)}
                >
                  No
                </button>
                <button
                  type="button"
                  className="px-6 py-2 bg-red-700 hover:bg-red-800 text-white rounded-md text-sm font-medium disabled:opacity-50"
                  disabled={loading}
                  onClick={handleRegisterYes}
                >
                  {loading ? "Sending..." : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )
    : null

  return (
    <>
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!open && step !== "registration" && !showNotFoundPopup) {
        onClose()
      }
    }}>
      <DialogContent className="w-[90vw] sm:w-[95vw] max-w-[450px] p-4 sm:p-6 max-h-[90vh] overflow-y-auto" hideClose={step === "registration"} onInteractOutside={(e) => step === "registration" && e.preventDefault()}>
        <div className="flex flex-col items-center">
          <img src="/images/pranaam-logo.png" alt="Pranaam 365" className="h-16 sm:h-24 mb-3 sm:mb-4" />
          <DialogHeader className="text-center w-full">
            <DialogTitle className="text-xl sm:text-1xl font-bold mb-1 text-center">
              {step === "phone" ? (mode === "login" ? "Login" : "Signup") : step === "otp" ? "Verify OTP" : "Registration"}
            </DialogTitle>
            <p className="text-gray-500 text-xs sm:text-sm text-center">
              {step === "phone"
                ? `Enter your phone number to receive an OTP for ${mode === "login" ? "login" : "signup"}.`
                : step === "otp"
                ? `We've sent a verification code to +91 ${phone}`
                : "Complete your registration"}
            </p>
          </DialogHeader>
        </div>
       
        {step === "phone" ? (
          <form onSubmit={handleSendOTP} className="space-y-3 mt-3 sm:mt-4">
            <div className="mb-4">
              <label className="block text-gray-700 mb-1 font-medium">
                Phone Number
              </label>
 
              <div className="flex border border-gray-300 rounded-md overflow-hidden">
                <span className="bg-gray-100 text-gray-600 px-4 flex items-center select-none border-r border-gray-300">
                  +91
                </span>
                <Input
                  id="phone"
                  type="tel"
                  placeholder="Enter your phone number"
                  value={phone}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '').slice(0, 10)
                    setPhone(val)
                    if (phoneError) setPhoneError("")
                  }}
                  required
                  maxLength={10}
                 class="flex-grow px-3 py-3 outline-none"
                />
              </div>
              {phoneError && <p className="text-red-600 text-xs mt-1">{phoneError}</p>}
            </div>
            <Button type="submit" className="w-full bg-red-700 hover:bg-red-800 py-4 sm:py-5 text-xs sm:text-sm" disabled={loading}>
              {loading ? "Sending..." : "Send OTP"}
            </Button>
          </form>
        ) : step === "otp" ? (
          <form onSubmit={handleVerifyOTP} className="space-y-3 sm:space-y-4 mt-3 sm:mt-4">
            <div className="space-y-3 sm:space-y-4">
              <Label className="text-xs sm:text-sm font-medium text-center block">Enter verification code</Label>
              <div className="flex justify-center gap-1.5 sm:gap-2">
                {[...Array(6)].map((_, i) => (
                  <Input
                    key={i}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    className="w-10 h-10 sm:w-12 sm:h-12 text-center text-lg sm:text-xl font-semibold border-2 rounded-lg p-0 text-gray-900"
                    value={otp[i] || ''}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '')
                      if (!val && otp[i]) {
                        const newOtp = otp.split('')
                        newOtp[i] = ''
                        setOtp(newOtp.join(''))
                        return
                      }
                      if (!val) return
                      const newOtp = otp.split('')
                      newOtp[i] = val.slice(-1)
                      setOtp(newOtp.join(''))
                      if (val && i < 5) {
                        const nextInput = e.target.parentElement?.children[i + 1]
                        nextInput?.focus()
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Backspace' && !otp[i] && i > 0) {
                        const prevInput = e.target.parentElement?.children[i - 1]
                        prevInput?.focus()
                      }
                    }}
                  />
                ))}
              </div>
            </div>
            {otpError && (
              <p className="text-center text-xs sm:text-sm text-red-600 font-medium">{otpError}</p>
            )}
            <p className="text-center text-xs sm:text-sm text-gray-500">
              {timer > 0 ? (
                `Resend code in ${timer}s`
              ) : (
                <button
                  type="button"
                  onClick={handleResendOTP}
                  className="text-red-700 font-medium"
                >
                  Resend OTP
                </button>
              )}
            </p>
            <Button type="submit" className="w-full bg-red-700 hover:bg-red-800 py-4 sm:py-5 text-xs sm:text-sm" disabled={loading}>
              {loading ? "Verifying..." : "Verify & Continue"}
            </Button>
            <button type="button" onClick={() => setStep("phone")} className="w-full text-center text-red-700 font-medium text-xs sm:text-sm">
              Back to Login
            </button>
          </form>
        ) : (
          <form onSubmit={handleRegistration} className="space-y-3 mt-3">
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-2">
                <Label htmlFor="firstName" className="text-xs font-medium">First Name <span className="text-red-600">*</span></Label>
                <Input
                  id="firstName"
                  placeholder="First name"
                  value={registrationData.firstName}
                  onChange={(e) => setRegistrationData({...registrationData, firstName: e.target.value.replace(/[^a-zA-Z\s]/g, '')})}
                  required
                  className="text-xs py-4"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="lastName" className="text-xs font-medium">Last Name <span className="text-red-600">*</span></Label>
                <Input
                  id="lastName"
                  placeholder="Last name"
                  value={registrationData.lastName}
                  onChange={(e) => setRegistrationData({...registrationData, lastName: e.target.value.replace(/[^a-zA-Z\s]/g, '')})}
                  required
                  className="text-xs py-4"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-2">
                <Label htmlFor="dob" className="text-xs font-medium">Date of birth <span className="text-red-600">*</span></Label>
                <Input
                  id="dob"
                  type={registrationData.dob ? "date" : "text"}
                  onFocus={(e) => e.target.type = "date"}
                  onBlur={(e) => { if (!e.target.value) e.target.type = "text" }}
                  placeholder="Date of Birth"
                  value={registrationData.dob}
                  onChange={(e) => setRegistrationData({...registrationData, dob: e.target.value})}
                  required
                  max={new Date().toISOString().split('T')[0]}
                  className="text-xs py-4"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="gender" className="text-xs font-medium">Gender <span className="text-red-600">*</span></Label>
                <select
                  id="gender"
                  value={registrationData.gender}
                  onChange={(e) => setRegistrationData({...registrationData, gender: e.target.value})}
                  required
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-red-700"
                >
                  <option value="">Choose Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-xs font-medium">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="Email"
                  value={registrationData.email}
                  onChange={(e) => setRegistrationData({...registrationData, email: e.target.value})}
                  className="text-xs py-4"
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="stateId" className="text-xs font-medium">State <span className="text-red-600">*</span></Label>
                <select
                  id="stateId"
                  value={registrationData.stateId}
                  onChange={(e) => setRegistrationData({...registrationData, stateId: e.target.value})}
                  required
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-red-700"
                >
                  <option value="">Select State</option>
                  {states.map(s => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-2">
                <Label htmlFor="city" className="text-xs font-medium">City</Label>
                <Input
                  id="city"
                  placeholder="City"
                  value={registrationData.city}
                  onChange={(e) => setRegistrationData({...registrationData, city: e.target.value.replace(/[^a-zA-Z\s]/g, '')})}
                  className="text-xs py-4"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="address" className="text-xs font-medium">Address <span className="text-red-600">*</span></Label>
                <textarea
                  id="address"
                  placeholder="Address"
                  value={registrationData.address}
                  onChange={(e) => setRegistrationData({...registrationData, address: e.target.value})}
                  required
                  rows={2}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-red-700"
                />
              </div>
            </div>
            <Button type="submit" className="w-full bg-red-700 hover:bg-red-800 py-4 text-xs" disabled={loading}>
              {loading ? "Registering..." : "Register"}
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>

    {notFoundPopup}
    </>
  )
}
